import { css } from '@emotion/core';
import React, { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import FlyoutHeader from './flyout-header';

const FlyoutContainer = ({ children, title }) => {
  const { FlyoutModalManager } = useContext(AngularServicesContext);
  const styles = css`
  .content{
    display:flex;
    flex-direction:column;
  }
`;

  return (
    <div className='flyout-container' css={styles}>
      <FlyoutHeader title={title} onClose={FlyoutModalManager?.closeFlyout} />
      <div className='content'>
        {children}
      </div>
    </div>
  );
};

export default FlyoutContainer;
